import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { TabPanel } from "../../../components/tab-panel";
import { EditContactComponent } from "./edit-contact.component";
import { ProjectDuxComponent } from "./project-dux/project-dux.component";

interface SaveContactDialogProps {
    data: any;
    onClose: () => void;
}

export const SaveContactDialog = ({
    data,
    onClose,
}: SaveContactDialogProps) => {
    const [tabView, setTabView] = useState<string>('edit-contact');

    const handleTabsChange = (event: any, value: any) => {
        setTabView(value);
    };

    return (
        <Dialog open={true} fullWidth={true} maxWidth={'xl'}>
            <DialogTitle id="dialog-title" sx={{ p: 0, m: 0 }}>
                <Tabs value={tabView} onChange={handleTabsChange}>
                    <Tab value="edit-contact" label={<div>UPDATE CONTACT</div>} />
                    <Tab value="dux-contact" label={<div>SYNC WITH DUX</div>} />
                </Tabs>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 3,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <DialogContent dividers className="popupDilog">
                <TabPanel selectedValue={tabView} value="edit-contact">
                    <EditContactComponent contactData={data} onClosed={onClose} />
                </TabPanel>
                <TabPanel selectedValue={tabView} value="dux-contact">
                    <ProjectDuxComponent contactID={data?.contactsID} onClosed={onClose} />
                </TabPanel>
            </DialogContent>
        </Dialog >
    );
}